import { SET_MODAL } from 'actions/types';

const initialState = {};

export default (state = initialState, action: { type: string; payload: object }) => {
  if (action.type === SET_MODAL) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return state;
};
